import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";

export async function sendMail({
  title,
  html,
  emailReceivers
}: {
  title: string;
  html: string;
  emailReceivers: string[];
}): Promise<string> {
  const request = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("send_mails");

  const res = await request({
    title,
    html,
    emailReceivers
  });
  if (!res.data.success) {
    throw new Error("error occurred while sending emails.");
  }

  return res.data.success;
}
